<template>
  <v-row class="px-4" no-gutters>
    <v-btn v-if="type === 'phone'" class="mx-1" icon @click="run('whatsapp')">
      <v-icon size="20">
        mdi-whatsapp
      </v-icon>
    </v-btn>
    <v-btn v-if="type === 'phone'" class="mx-1" icon @click="run('call')">
      <v-icon size="19">
        mdi-phone
      </v-icon>
    </v-btn>
    <v-btn v-if="type === 'email'" class="mx-1" icon @click="run('email')">
      <v-icon size="20">
        mdi-email
      </v-icon>
    </v-btn>
    <v-btn class="mx-1" icon @click="run('copy')">
      <v-icon size="20">
        mdi-content-copy
      </v-icon>
    </v-btn>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
import { RegisterLeadContactAttempt } from "@/api/lead-api";

export default {
  name: "LeadContactActions",
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ["email", "phone"].includes(value)
    },
    value: {
      type: String,
      default: ""
    },
    leadId: {
      type: String,
      default: ""
    },
    contactLeadId: {
      type: String,
      default: ""
    }
  },
  methods: {
    ...mapActions({
      fetchUpdatelLead: "leads/fetchUpdatelLead"
    }),
    run(action) {
      const medium = () => {
        switch (action) {
          case "whatsapp":
            return "Whatsapp";
          case "email":
            return "Email";
          case "call":
            return "Llamada";
          default:
            return null;
        }
      };

      const source = () => {
        switch (action) {
          case "whatsapp":
            return "whatsapp";
          case "email":
            return "email";
          case "call":
            return "call";
          default:
            return null;
        }
      };

      if (medium() && this.leadId && this.contactLeadId) {
        this.fetchUpdatelLead({
          leadId: this.leadId,
          contactLeadId: this.contactLeadId,
          lead: { contacted: medium() }
        });
      }

      if (source() && this.leadId) {
        RegisterLeadContactAttempt({
          idLead: this.leadId,
          source: source(),
          attempts: 1
        }).catch(() => {});
      }

      switch (action) {
        case "whatsapp":
          window.open(
            `//api.whatsapp.com/send?phone=+${this.value}&text=+${this.value}`,
            "_blank"
          );
          break;
        case "email":
          window.open(`mailto:${this.value}`, "_blank");
          break;
        case "call":
          window.open(`tel://${this.value}`, "_blank");
          break;
        default:
          navigator.clipboard.writeText(this.value);
          break;
      }
    }
  }
};
</script>
